export function getSelectionList() {
  var shortCutStyle = `color:#c4c4c4;float:right;display:inline - flex`;
  return [

        { id: '1', value: 'transaction', text: `Transactions <strong style=${shortCutStyle}> Ctrl+ALT+1</strong>`},
        { id: '2', value: 'authorization', text: `Authorizations <strong style=${shortCutStyle}> Ctrl+ALT+2</strong>` },
        { id: '3', value: 'merchant', text: `Merchants <strong style=${shortCutStyle}> Ctrl+ALT+3</strong>`},
  ];
}
